module.exports = __webpack_public_path__ + "assets/img/enterprise-domain-why-icon-1.a3703cbd.png";